"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosPOSTransactionSchema = exports.APosTransactionPaymentSchema = exports.APosCartItemSchema = exports.APosTransactionStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const order_schema_1 = require("./order.schema");
const pos_signature_schema_1 = require("./pos-signature.schema");
const lottery_records_schema_1 = require("./lottery-records.schema");
exports.APosTransactionStatusSchema = zod_1.z.enum([
    'in_progress', 'completed', 'voided', 'suspended',
]);
exports.APosCartItemSchema = zod_1.z.object({
    lineId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    barcode: zod_1.z.string().optional(),
    quantity: zod_1.z.number().int().positive(),
    unitPrice: zod_1.z.number().nonnegative(),
    discount: zod_1.z.number().nonnegative().default(0),
    lineTotal: zod_1.z.number().nonnegative(),
    taxAmount: zod_1.z.number().nonnegative().default(0),
    promotionId: id_schema_1.EntityIdSchema.optional(),
    couponCode: zod_1.z.string().optional(),
    isAgeRestricted: zod_1.z.boolean().default(false),
    isWeighted: zod_1.z.boolean().default(false),
    weight: zod_1.z.number().positive().optional(),
    lottery: lottery_records_schema_1.APosLotteryLineSchema.optional(),
});
exports.APosTransactionPaymentSchema = zod_1.z.object({
    paymentId: id_schema_1.EntityIdSchema,
    method: order_schema_1.APosPaymentMethodSchema,
    amount: zod_1.z.number().nonnegative(),
    tendered: zod_1.z.number().nonnegative().optional(),
    change: zod_1.z.number().nonnegative().optional(),
    stripePaymentIntentId: zod_1.z.string().optional(),
    cardBrand: zod_1.z.string().optional(),
    cardLast4: zod_1.z.string().length(4).optional(),
    processedAt: zod_1.z.number(),
    signature: pos_signature_schema_1.APosPaymentSignatureSchema.optional(),
});
exports.APosPOSTransactionSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    transactionId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    terminalId: zod_1.z.string().optional(),
    sessionId: zod_1.z.string().optional(),
    items: zod_1.z.array(exports.APosCartItemSchema).default([]),
    subtotal: zod_1.z.number().nonnegative().default(0),
    totalDiscount: zod_1.z.number().nonnegative().default(0),
    taxTotal: zod_1.z.number().nonnegative().default(0),
    grandTotal: zod_1.z.number().nonnegative().default(0),
    payments: zod_1.z.array(exports.APosTransactionPaymentSchema).default([]),
    amountPaid: zod_1.z.number().nonnegative().default(0),
    amountDue: zod_1.z.number().nonnegative().default(0),
    customerId: id_schema_1.EntityIdSchema.optional(),
    loyaltyPointsEarned: zod_1.z.number().int().nonnegative().optional(),
    loyaltyPointsRedeemed: zod_1.z.number().int().nonnegative().optional(),
    ageVerificationRequired: zod_1.z.boolean().default(false),
    ageVerified: zod_1.z.boolean().default(false),
    alertsChecked: zod_1.z.boolean().default(false),
    alertOverrides: zod_1.z.array(zod_1.z.object({
        alertId: zod_1.z.string(),
        overriddenBy: zod_1.z.string(),
        overriddenAt: zod_1.z.number(),
        reason: zod_1.z.string().optional(),
    })).default([]),
    status: exports.APosTransactionStatusSchema.default('in_progress'),
    staffId: id_schema_1.EntityIdSchema,
    staffName: zod_1.z.string().optional(),
    orderId: id_schema_1.EntityIdSchema.optional(),
    notes: zod_1.z.string().max(2000).optional(),
    voidReason: zod_1.z.string().max(500).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=pos-transaction.schema.js.map